<div class="container-fluid">
    <app-pagetitle title="Client stamp orders"></app-pagetitle>

    <div class="page-content-wrapper">

        <app-loader [loading]="loading"></app-loader>

        <div [class.loading-content]="loading">

            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <app-filter (filterChange)="filterChange($event)" [statusOptions]="statusOptions"
                                searchBY="BSR Id, Client, Email & Maker"></app-filter>

                            <p-table #dt [value]="orders" [lazy]="true" (onLazyLoad)="getClientOrders($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>BSR Id</th>
                                        <th>Client</th>
                                        <th>Maker</th>
                                        <th>Total Value</th>
                                        <th>Status</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-document>
                                    <tr>
                                        <td class="fw-bold">{{ document.bsrId }}</td>

                                        <td>
                                            <div>{{ document.clientName }}</div>
                                            <small class="text-muted">{{ document.clientEmail }}</small>
                                        </td>

                                        <td>{{ document.userName }}</td>

                                        <td>₹{{ document.totalValue }}</td>

                                        <td>
                                            <span class="badge rounded-pill px-2 py-1 small"
                                                [ngClass]="getStatusClass(document.status)">
                                                {{ document.status }}
                                            </span>
                                        </td>

                                        <td>{{ document?.createdAt | date:'dd/MM/yyyy hh:mm a' }}</td>

                                        <td>
                                            <button pButton type="button" icon="pi pi-eye"
                                                class="p-button-rounded p-button-text p-button-sm" ngbTooltip="Detail"
                                                (click)="viewOrderDetail(document)">
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="8" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No document found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <ng-template #orderModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">Order Detail</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
            </div>

            <div class="modal-body">

                <div class="row">

                    <!-- BSR Id -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">BSR Id</div>
                        <div>{{ orderDetail?.bsrId || '-' }}</div>
                    </div>

                    <!-- Status -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Status</div>
                        <span class="badge rounded-pill px-2 py-1" [ngClass]="getStatusClass(orderDetail?.status)">
                            {{ orderDetail?.status || '-' }}
                        </span>
                    </div>

                    <!-- Client Name -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Client Name</div>
                        <div>{{ orderDetail?.clientName || '-' }}</div>
                    </div>

                    <!-- Client Email -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Client Email</div>
                        <div>{{ orderDetail?.clientEmail || '-' }}</div>
                    </div>

                    <!-- Requested By -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Maker Name</div>
                        <div>{{ orderDetail?.userName || '-' }}</div>
                    </div>

                    <!-- Total Value -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Total Value</div>
                        <div>₹{{ orderDetail?.totalValue || 0 }}</div>
                    </div>

                    <!-- Items -->
                    <div class="col-md-12 mb-3">
                        <div class="fw-semibold mb-1">Items</div>
                        <div class="table-responsive">
                            <table class="table table-sm table-bordered mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th>State</th>
                                        <th class="text-end">Denomination</th>
                                        <th class="text-end">Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of orderDetail?.items">
                                        <td>{{ item.stateName }}</td>
                                        <td class="text-end">₹{{ item.denomination }}</td>
                                        <td class="text-end">{{ item.quantity }}</td>
                                    </tr>
                                    <tr *ngIf="!orderDetail?.items?.length">
                                        <td colspan="3" class="text-center text-muted">No items</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Excel File -->
                    <div class="col-md-6 mb-3" *ngIf="orderDetail?.excelUrl">
                        <div class="fw-semibold">Uploaded File</div>
                        <a [href]="orderDetail?.excelUrl" target="_blank" rel="noopener">
                            {{ orderDetail?.originalFileName || 'Download' }}
                        </a>
                    </div>

                    <!-- Payment Proof -->
                    <div class="col-md-6 mb-3" *ngIf="orderDetail?.paymentProofUrl">
                        <div class="fw-semibold">Payment Proof</div>
                        <a [href]="orderDetail?.paymentProofUrl" target="_blank" rel="noopener">
                            View Payment Proof
                        </a>
                    </div>

                    <!-- Created At -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Created At</div>
                        <div>{{ orderDetail?.createdAt | date:'medium' }}</div>
                    </div>

                    <!-- Updated At -->
                    <div class="col-md-6 mb-3">
                        <div class="fw-semibold">Updated At</div>
                        <div>{{ orderDetail?.updatedAt | date:'medium' }}</div>
                    </div>

                </div>

            </div>

            <div class="modal-footer" *ngIf="orderDetail?.status === 'ORDER_CREATED'">
                <button type="button" class="btn btn-primary d-inline-flex align-items-center"
                    (click)="onGenerateInvoice()" [disabled]="generatingInvoice">
                    <i class="mdi mdi-receipt me-1"></i>
                    {{ generatingInvoice ? 'Generating...' : 'Generate Invoice' }}
                </button>
            </div>

            <div class="modal-footer d-block" *ngIf="orderDetail?.status === 'PAYMENT_SUBMITTED'">
                <div class="mb-3 d-flex gap-4">
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="paymentAction" id="paymentVerify"
                            value="VERIFY" [(ngModel)]="paymentAction">
                        <label class="form-check-label" for="paymentVerify">Verify Payment</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="paymentAction" id="paymentReject"
                            value="REJECT" [(ngModel)]="paymentAction">
                        <label class="form-check-label" for="paymentReject">Reject Payment</label>
                    </div>
                </div>

                <div class="mb-2" *ngIf="paymentAction">
                    <label class="form-label fw-semibold">Reason</label>
                    <textarea class="form-control" rows="2" [(ngModel)]="reason"
                        [placeholder]="paymentAction === 'REJECT' ? 'Enter reason for rejecting the payment' : 'Enter reason for verifying the payment'"></textarea>
                </div>

                <div *ngIf="paymentAction === 'VERIFY'" class="text-end">
                    <button type="button" class="btn btn-primary d-inline-flex align-items-center"
                        (click)="orderProcess()" [disabled]="generatingInvoice">
                        <i class="mdi mdi-receipt me-1"></i>
                        {{ generatingInvoice ? 'Verifying...' : 'Verify Payment' }}
                    </button>
                </div>

                <div *ngIf="paymentAction === 'REJECT'" class="text-end">
                    <button type="button" class="btn btn-danger d-inline-flex align-items-center"
                        (click)="onRejectPayment()" [disabled]="rejectingPayment">
                        <i class="mdi mdi-close-circle me-1"></i>
                        {{ rejectingPayment ? 'Rejecting...' : 'Reject Payment' }}
                    </button>
                </div>
            </div>
        </ng-template>
    </div>
</div>